// Test de RUTA RECOMENDADA — siete preguntas, y nadie contesta las siete.
//
// LO QUE ERA Y POR QUE SE TIRO ENTERO. Eran veintidos preguntas que venian del «Test Alpha»,
// un test de personalidad. En septiembre dejo de dar un perfil y paso a recomendar ruta, pero
// **solo se cambiaron los pesos: las preguntas se quedaron**. Un cuestionario de personalidad
// no se convierte en orientador recalibrando una tabla, y el resultado se medio el 18 de
// octubre de 2026, pregunta por pregunta:
//
//   · ni una de las veintidos nombraba un idioma, un curso escolar, un examen ni una
//     asignatura — o sea, nada de lo que decide que curso le conviene a alguien;
//   · el resultado eran las cinco competencias, y detras de «Comunicacion» hay treinta y
//     ocho cursos: un alumno lo dijo con sus palabras, «muy general, no me aclaro»;
//   · contestando al azar salia Comunicacion el 48 % de las veces y Pensamiento critico el
//     34 %, con 5,7 puntos de margen medio entre el primero y el segundo;
//   · y **Cultura y politica era inalcanzable**: no existia forma de contestar que la
//     recomendara, porque su techo eran 100 puntos contra los 194 de Pensamiento critico.
//
// LO QUE PREGUNTA AHORA: a que viene, que se le atraganta, que idioma y cuanto sabe ya,
// cuanto tiempo tiene, si prefiere algo corto o largo, y que le apetece. Hechos y gusto, en
// ese orden, porque los hechos filtran y el gusto ordena.
//
// Y EL CURSO ESCOLAR NO SE PREGUNTA: la cuenta lo sabe desde el registro. Preguntar dos veces
// lo mismo es no haber escuchado la primera, y ademas filtra de entrada: a alguien de 1.º de
// la ESO no se le recomienda Historia de la Filosofia de la PAU.
//
// NADIE LAS CONTESTA TODAS. R2 sale a quien viene a aprobar o a la PAU; R3 y R4, a quien viene
// por un idioma. Las ramas se declaran en la propia pregunta con `si`, y quien decide es
// `lib/ramaDelTest.mjs`.
//
// LOS PESOS YA NO SON COMPETENCIAS, SON HECHOS. `meta:aprobar`, `nivel:b1`, `tiempo:poco`: lo
// que el alumno DICE, con su nombre, sin etiqueta intermedia. El servidor los cruza con los
// cursos publicados —`backend/app/modules/test/service.py`— y de ahi sale el encaje. Guardar
// `filosofia: 9` junto a las respuestas de un menor era guardar una deduccion nuestra; esto es
// lo que contesto.
export const PREGUNTAS_RUTA = [
  {
    id: "r1",
    // SE DICE ANTES (R5, 24 oct 2026): esta respuesta y la del atasco las ve el profesor de su
    // clase, en la tarjeta del alumno. Lo declara también la política de privacidad.
    prompt: "Antes de nada, lo que más importa. Si vas con una clase, esto lo verá tu profesor:",
    question: "¿A qué vienes?",
    options: [
      { id: "a", label: "Quiero aprobar una asignatura que llevo este curso", weights: { "meta:aprobar": 1 } },
      { id: "b", label: "Me preparo la selectividad", weights: { "meta:pau": 1 } },
      { id: "c", label: "Quiero aprender un idioma", weights: { "meta:idioma": 1 } },
      { id: "d", label: "Quiero estudiar mejor, me da igual la asignatura", weights: { "meta:metodo": 1 } },
      { id: "e", label: "Curiosear: a ver qué hay", weights: { "meta:curiosear": 1 } },
    ],
  },
  {
    id: "r2",
    // Solo a quien viene a aprobar o a la PAU. A quien viene por el aleman, preguntarle que
    // asignatura se le atraganta es preguntarle por algo que no ha venido a resolver.
    si: { pregunta: "r1", opciones: ["a", "b"] },
    prompt: "Vamos a lo concreto:",
    question: "¿Cuál se te está atragantando?",
    options: [
      { id: "a", label: "Filosofía o Historia de la Filosofía", weights: { "atasco:filosofia": 1 } },
      { id: "b", label: "Lengua y Literatura Castellana", weights: { "atasco:lengua": 1 } },
      { id: "c", label: "Latín o Cultura Clásica", weights: { "atasco:clasicas": 1 } },
      { id: "d", label: "Música", weights: { "atasco:musica": 1 } },
      { id: "e", label: "Inglés", weights: { "atasco:ingles": 1 } },
      { id: "f", label: "Ninguna en concreto: voy regular en varias", weights: { "atasco:varias": 1 } },
    ],
  },
  {
    id: "r3",
    si: { pregunta: "r1", opciones: ["c"] },
    prompt: "De idiomas tenemos dos, y seis niveles de cada uno:",
    question: "¿Qué idioma, y para qué?",
    options: [
      { id: "a", label: "Inglés, para el instituto", weights: { "idioma:ingles": 1, "para:instituto": 1 } },
      { id: "b", label: "Inglés, para sacarme un título (B1, B2, C1…)", weights: { "idioma:ingles": 1, "para:titulo": 1 } },
      { id: "c", label: "Alemán, desde cero", weights: { "idioma:aleman": 1, "nivel:cero": 1 } },
      { id: "d", label: "Alemán, ya sé algo", weights: { "idioma:aleman": 1 } },
      { id: "e", label: "Los dos", weights: { "idioma:ingles": 1, "idioma:aleman": 1 } },
    ],
  },
  {
    id: "r4",
    // Ni a quien empieza de cero: ya ha dicho su nivel al decir «desde cero».
    si: { pregunta: "r3", opciones: ["a", "b", "d", "e"] },
    prompt: "Y para no empezarte por donde no toca:",
    // POR LO QUE SABE HACER Y NO POR EL NOMBRE DEL NIVEL. Nadie sabe si es B1; todo el mundo
    // sabe si puede escribir una reclamacion. El nombre del idioma se pone al vuelo con lo
    // contestado en r3: preguntar «en ese idioma» obliga a acordarse de la pantalla anterior.
    question: "En el idioma que has elegido, ¿qué eres capaz de hacer ya?",
    options: [
      { id: "a", label: "Me presento y digo cosas sueltas", weights: { "nivel:a1": 1 } },
      { id: "b", label: "Cuento lo que hice el fin de semana sin bloquearme", weights: { "nivel:a2": 1 } },
      { id: "c", label: "Me puedo entender con la gente en un país donde no se hable español", weights: { "nivel:b1": 1 } },
      { id: "d", label: "Discuto y defiendo una opinión por escrito", weights: { "nivel:b2": 1 } },
      { id: "e", label: "Puedo leerlo y entenderlo con facilidad", weights: { "nivel:c1": 1 } },
    ],
  },
  {
    id: "r5",
    prompt: "Lo que decide el tamaño de lo que te recomendemos:",
    question: "¿Cuántos días a la semana vas a poder sentarte?",
    options: [
      { id: "a", label: "Uno o dos", weights: { "tiempo:poco": 1 } },
      { id: "b", label: "Tres o cuatro", weights: { "tiempo:medio": 1 } },
      { id: "c", label: "Casi todos los días", weights: { "tiempo:mucho": 1 } },
      { id: "d", label: "No lo sé todavía", weights: { "tiempo:nose": 1 } },
    ],
  },
  {
    id: "r6",
    prompt: "Y cómo te gusta empezar:",
    question: "¿Prefieres terminar algo corto o meterte en algo largo?",
    options: [
      { id: "a", label: "Algo corto, para ver que lo acabo", weights: { "tamano:corto": 1 } },
      { id: "b", label: "Algo largo, si merece la pena", weights: { "tamano:largo": 1 } },
      { id: "c", label: "Me da igual: lo que me sirva más", weights: { "tamano:igual": 1 } },
    ],
  },
  {
    id: "r7",
    // LA UNICA DE GUSTO, Y ES LA UNICA QUE SE SALVO DE LAS VEINTIDOS. Era «¿Que disciplina te
    // atrae mas ahora mismo?» y sus opciones eran «Filosofia y epistemologia» y «Psicoanalisis
    // y teoria del sujeto»: un alumno de 3.º no se reconoce ahi, y elegir una opcion que no
    // entiendes es contestar al azar. Ahora son las asignaturas que estan publicadas, con el
    // nombre que tienen en el catalogo. Vive tambien en el test de intereses, donde alimenta
    // los ejemplos de Socrates; aqui decide la competencia.
    prompt: "La última, y esta es de gusto:",
    question: "¿De cuál te gustaría saber más?",
    options: [
      { id: "a", label: "Filosofía, ética y los grandes debates", weights: { "gusto:filosofia": 1 } },
      { id: "b", label: "Escribir y leer mejor: gramática, ortografía, literatura", weights: { "gusto:literatura": 1 } },
      { id: "c", label: "Idiomas: inglés o alemán", weights: { "gusto:idiomas": 1 } },
      { id: "d", label: "Psicología: por qué hacemos lo que hacemos", weights: { "gusto:psicologia": 1 } },
      { id: "e", label: "Latín, cultura clásica y política", weights: { "gusto:cultura-clasica": 1 } },
      { id: "f", label: "Música", weights: { "gusto:musica": 1 } },
    ],
  },
];
